import Loading from "components/Loading";
import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import COLOR from "utils/constants/color";
import { useLocation } from "react-router-dom";

const BookImage = ({
  src,
  imageCache,
  onLoad,
  onError,
  className = "",
  alt = "Book page",
}) => {
  const location = useLocation();
  const [imageLoading, setImageLoading] = useState(false);

  const isCurrentImageCached = useMemo(() => {
    return src ? imageCache.has(src) : false;
  }, [src, imageCache]);

  useEffect(() => {
    if (src) {
      const isCached = imageCache.has(src);
      setImageLoading(!isCached);
    }
  }, [src, imageCache]);

  const handleImageLoad = () => {
    setImageLoading(false);
    if (onLoad) onLoad();
  };

  const handleImageError = () => {
    setImageLoading(false);
    if (onError) onError();
  };

  const showLoading = imageLoading && !isCurrentImageCached;

  return (
    <ImageContainer>
      {showLoading && (
        <LoadingContainer>
          <LoadingText>
            <Loading size={18} />
          </LoadingText>
        </LoadingContainer>
      )}
      <StyledImage
        src={src}
        alt={alt}
        onLoad={handleImageLoad}
        onError={handleImageError}
        isLoading={imageLoading}
        isCached={isCurrentImageCached}
        className={className}
        isResource={location.pathname.includes("/video") ? true : false}
      />
    </ImageContainer>
  );
};

export default BookImage;

// Styled Components
const ImageContainer = styled.div`
  position: relative;
  height: 97%;
  background-color: ${COLOR.white};
  width: 100%;
  min-height: 600px;
  @media (min-width: 769px) and (max-width: 1024px) {
    /* Tablet and smaller screen styles */
    min-height: 400px; 
  }
  @media (max-width: 768px) {
    /* Tablet and smaller screen styles */
    min-height: 300px; 
  }
    @media (max-width: 500px) {
    /* Tablet and smaller screen styles */
    min-height: 100px; 
  }

`;

const StyledImage = styled.img`
  background-color: ${COLOR.white};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  object-fit: ${(props) => props?.isResource ? "contain" : "fill"};
  height: 100%;
  width: 100%;
  display: ${(props) =>
    props.isLoading && !props.isCached ? "none" : "block"};
  opacity: ${(props) => (props.isCached ? 1 : props.isLoading ? 0 : 1)};
  transition: opacity 0.2s ease-in-out;

  @media print {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
`;

const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: ${COLOR.white};
  z-index: 1;
`;

const LoadingText = styled.div`
  font-size: 16px;
  color: ${COLOR.black600};
`;
